import validate from 'validator';

const isValidURL = value => {
  const trimmedValue = value.trim();
  if (validate.isURL(trimmedValue) || validate.contains(trimmedValue, '.'))
    return true;
  return false;
};

const showErrorMessageAndAddErrorClass = (element, message) => {
  try {
    if (element) {
      element.classList.add('error');

      element.classList.add('focus');

      const code = element.querySelector('code');
      code.innerText = message;
    }
  } catch (err) {
    console.log(err);
  }
};

const checkIfHtmlTag = name => {
  try {
    const htmlTagPattern = /<[^>]*>/;
    const partialTagPattern = /<[a-zA-Z]+/;

    let unescapedUnivName = validate.unescape(name);

    unescapedUnivName = unescapedUnivName.replaceAll('&lt', '&lt;');

    unescapedUnivName = unescapedUnivName.replaceAll('&gt', '&gt;');

    unescapedUnivName = validate.unescape(unescapedUnivName);

    if (
      htmlTagPattern.test(name) ||
      partialTagPattern.test(name) ||
      htmlTagPattern.test(unescapedUnivName) ||
      partialTagPattern.test(unescapedUnivName)
    ) {
      return true;
    }
  } catch (error) {
    console.log(error);
  }

  return false;
};

const validEmail = (email, element) => {
  try {
    let flagEmail = true;

    if (email === null && email.trim() === '') {
      flagEmail = false;
    } else {
      flagEmail = validate.isEmail(email.trim());
    }

    if (!flagEmail) {
      showErrorMessageAndAddErrorClass(
        element.parentElement,
        'Please enter a valid email'
      );
      return flagEmail;
    }
    element.parentElement.classList.add('focus');
    element.parentElement.classList.remove('error');
    return flagEmail;
  } catch (err) {
    console.log(err);
    return false;
  }
};

const validatePassword = (password, element, isLogin) => {
  try {
    let flagPassword = true;
    if (password === null || password.trim() === '') {
      showErrorMessageAndAddErrorClass(
        element.parentElement,
        'Please enter a valid password!'
      );
      return false;
    }

    if (isLogin) {
      if (password.trim().length < 6 || password.trim().length > 64) {
        if (password.trim().length < 6) {
          showErrorMessageAndAddErrorClass(
            element.parentElement,
            'Please ensure that your password contains at least 6 characters!'
          );
        } else if (password.trim().length > 64) {
          showErrorMessageAndAddErrorClass(
            element.parentElement,
            'Please ensure that your password does not exceed 64 characters'
          );
        }

        return false;
      }
      const passwordPattern = /^[^\s](?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9.!&@/()=?+*~#'_:.,;-\s]+)[^\s]$/;

      flagPassword = passwordPattern.test(password);

      if (!flagPassword) {
        showErrorMessageAndAddErrorClass(
          element.parentElement,
          'Please ensure that your password is a combination of letters and numbers!'
        );

        return false;
      }
    }
    element.parentElement.classList.add('focus');
    element.parentElement.classList.remove('error');
    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
};

const checkIfValidName = (name, firstName, lastName) => {
  const response = { status: false, message: '' };
  try {
    if (firstName === null || firstName.trim() === '') {
      response.message = 'Please give a valid name';
      return response;
    }
    if (name.trim().length < 2 || name.trim().length > 100) {
      if (name.trim().length < 2) {
        response.message = 'Your name should have atleast 2 characters';
        return response;
      }

      response.message = 'Your name should not exceed 100 characters';
      return response;
    }

    if (isValidURL(name)) {
      response.message =
        'Your name should not contain the special character dot (.)';
      return response;
    }

    if (checkIfHtmlTag(name)) {
      response.message = 'Your name should not contain a tag';
      return response;
    }

    if (name && lastName && lastName !== 'undefined') {
      if (isValidURL(lastName)) {
        response.message =
          'Your lastName should not contain the special character dot (.)';

        return response;
      }

      if (checkIfHtmlTag(lastName)) {
        response.message = 'Your lastName should not contain a tag';
        return response;
      }
    }

    if (isValidURL(firstName)) {
      response.message =
        'Your name should not contain the special character dot (.)';
      return response;
    }

    if (checkIfHtmlTag(firstName)) {
      response.message = 'Your name should not contain a tag';
      return response;
    }

    response.status = true;
    return response;
  } catch (err) {
    console.log(err);
    return false;
  }
};

const validName = (name, firstName, lastName, element) => {
  try {
    const response = checkIfValidName(name, firstName, lastName);
    if (response && response.status) {
      element.parentElement.classList.add('focus');
      element.parentElement.classList.remove('error');
      return true;
    }

    showErrorMessageAndAddErrorClass(
      element.parentElement,
      response.message ? response.message : 'Please give a valid name'
    );
    return false;
  } catch (err) {
    console.log(err);
    return false;
  }
};

const validSubdomain = (subdomain, element) => {
  try {
    let flagSubdomain = true;

    if (
      (subdomain && subdomain.trim().length < 3) ||
      subdomain.trim().length > 15
    ) {
      if (subdomain.length < 3)
        showErrorMessageAndAddErrorClass(
          element.parentElement,
          'Please select a domain name with atleast 3 characters'
        );
      else
        showErrorMessageAndAddErrorClass(
          element.parentElement,
          'Please select a domain name less than 15 characters'
        );

      return false;
    }
    const subdomainPattern = /^[a-zA-Z0-9-]*$/;

    flagSubdomain = subdomainPattern.test(subdomain.trim());

    if (!flagSubdomain) {
      showErrorMessageAndAddErrorClass(
        element.parentElement,
        'Please remove the special character'
      );
      return false;
    }
    element.parentElement.classList.add('focus');
    element.parentElement.classList.remove('error');
    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
};

const checkIfValidUnivName = univName => {
  const response = { status: false, message: '' };

  try {
    if (univName === null || univName.trim() === '') {
      response.message = 'Please give a valid university name';
      return response;
    }
    if (univName.trim().length < 3 || univName.trim().length > 100) {
      if (univName.trim().length < 3) {
        response.message =
          'Your university name should have atleast 3 characters';
        return response;
      }
      response.message =
        'Your university name should not exceed 100 characters';
      return response;
    }

    if (validate.isURL(univName)) {
      response.message =
        'Your university name should not contain the special character dot (.)';

      return response;
    }

    if (checkIfHtmlTag(univName)) {
      response.message = 'Your university name should not contain any tags';
      return response;
    }

    response.status = true;

    return response;
  } catch (err) {
    console.log(err);
    response.status(false);
    response.message(
      'Something went wrong while validating the university name'
    );
  }
  return response;
};

const validUnivName = (univName, element) => {
  try {
    const response = checkIfValidUnivName(univName);
    if (response && response.status) {
      element.parentElement.classList.add('focus');
      element.parentElement.classList.remove('error');
      return true;
    }

    showErrorMessageAndAddErrorClass(
      element.parentElement,
      response.message
        ? response.message
        : 'Please give a valid university name'
    );
    return false;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export {
  validUnivName,
  validSubdomain,
  validName,
  checkIfHtmlTag,
  validEmail,
  checkIfValidName,
  validatePassword,
  showErrorMessageAndAddErrorClass,
  isValidURL,
  checkIfValidUnivName
};
